module.exports = __webpack_public_path__ + "static/img/application6-2.233a884.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-2.jpg
// module id = Qv+Y
// module chunks = 0